import React, { useMemo, useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, Button, notification, Space, Row, Col } from 'antd';
import { useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
import { PlusOutlined } from "@ant-design/icons";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var ScreenSource = models.screens.ScreenSource;
import { ScreenCard } from './components/ScreenCard';
import { Loading } from '../../../../base-react/components/Loading';
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { getActiveScreenIds } from '../../../components/ApplicationStatusDot';
const { Title } = Typography;
export const EventScreens = () => {
    let { event_id } = useParams();
    const [, , , , , canEdit] = useCompetition(event_id);
    const [isLoading, setIsLoading] = useState(false);
    const screenSource = ScreenSource(event_id);
    const [items, loadingItems, errorItems] = Stream(screenSource);
    const [applications] = Stream(models.applications.CompetitionApplicationsSource(event_id));
    const activeScreenIds = useMemo(() => getActiveScreenIds(applications, event_id), [applications, event_id]);
    const onAddItem = async (item) => {
        setIsLoading(true);
        await Api.create(screenSource.url, item ? item : { screen_label: _T('screen.title'), screen_url: '', screen_target: '0' })
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        setIsLoading(false);
    };
    const onEditItem = async (item) => {
        setIsLoading(true);
        await Api.update(`${screenSource.url}/${item.screen_id}`, item)
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        setIsLoading(false);
    };
    const onDeleteItem = async (item, done) => {
        await Api.destroy(`${screenSource.url}/${item.screen_id}`)
            .then(() => {
            notification.success({
                message: _T('common.delete.success', { name: item.screen_label })
            });
        })
            .catch((err) => {
            setIsLoading(false);
            notification.error({
                message: err.message
            });
        });
        done();
    };
    const onChangePicture = async (item, imageData) => {
        await Api.call(`${screenSource.url}/${item.screen_id}`, 'set-picture', { picture: imageData });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('screen.plural')))),
        React.createElement(BodyContainer, null, loadingItems ? React.createElement(Loading, null) :
            React.createElement(Space, { orientation: 'vertical' },
                React.createElement(Row, { gutter: [16, 16] }, items && items.map((item, index) => React.createElement(Col, { key: index },
                    React.createElement(ScreenCard, { item: item, connected: activeScreenIds.has(String(item.screen_id)), onEditItem: onEditItem, onDeleteItem: onDeleteItem, onChangePicture: onChangePicture, disabled: !canEdit })))),
                React.createElement(Button, { size: 'large', type: 'primary', loading: isLoading, onClick: () => onAddItem(), icon: React.createElement(PlusOutlined, null), disabled: !canEdit }, _T('common.create', { name: _T('screen.title').toLocaleLowerCase() }))))));
};
